import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDeliveryNoteTemplatesStore } from "../../stores/delivery_note_templates";
import { useDeliveryNotesStore } from "../../stores/delivery_notes";
import { Role, useAuthStore } from "../../stores/auth";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";
import MobileActionBarContent from "../../components/mobile-action-bar/MobileActionBarContent";

function Home() {
  const { t } = useTranslation();
  const [templatesByIds, templatesAllIds, fetchSomeTemplates] =
    useDeliveryNoteTemplatesStore(
      (state) => [state.byIds, state.allIds, state.fetchSome],
      shallow,
    );

  const [totalDraft, fetchDraftTotal, totalReviewable, fetchReviewableTotal] =
    useDeliveryNotesStore(
      (state) => [
        state.totalDraft,
        state.fetchDraftTotal,
        state.totalReviewable,
        state.fetchReviewableTotal,
      ],
      shallow,
    );

  const [hasRole] = useAuthStore((state) => [state.hasRole], shallow);
  const isTechnician = hasRole(Role.TECHNICIAN);

  useEffect(() => {
    fetchSomeTemplates({ q: "", limit: 20, offset: 0 });
    if (isTechnician) {
      fetchDraftTotal();
    } else {
      fetchReviewableTotal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="my-auto my-md-0 px-3 px-md-0">
        {templatesAllIds.map((sid) => (
          <Link
            key={sid}
            to={`/delivery_notes/add?templateId=${sid}`}
            className="btn btn-lg btn-red w-100 mb-2 h-45px"
          >
            {t("delivery_notes.delivery_note")} {templatesByIds[sid].name}
          </Link>
        ))}
      </div>
      <MobileActionBarContent>
        {isTechnician ? (
          <Link
            to="/delivery_notes?filter=draft"
            className="btn btn-default w-100"
          >
            {t("menu.drafts")}
            {totalDraft > 0 && (
              <span className="badge bg-red ms-2">{totalDraft}</span>
            )}
          </Link>
        ) : (
          <Link
            to="/delivery_notes?filter=review"
            className="btn btn-default w-100"
          >
            {t("menu.review")}
            {totalReviewable > 0 && (
              <span className="badge bg-red ms-2">{totalReviewable}</span>
            )}
          </Link>
        )}
      </MobileActionBarContent>
    </div>
  );
}

export default Home;
